import React, { useCallback, useEffect, useState } from "react";
import {
  Avatar,
  Box,
  Button,
  Card,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Pagination,
  Radio,
  RadioGroup,
  Select,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import PlayCircleFilledWhiteOutlinedIcon from "@mui/icons-material/PlayCircleFilledWhiteOutlined";
import CloseIcon from "@mui/icons-material/Close";
import { toast } from "react-toastify";
import api_service from "../../network/api_callbacks";

const GOLD = "#CCA752";
const GREEN = "#26C02E";
const RED = "#D32F2F";

const initialFilters = {
  username: "",
  clipId: "",
  tag: "",
  approvedBy: "",
  publishedBy: "",
  rejectedBy: "",
  status: "ACTIVE",
  postedFrom: "",
  postedTo: "",
  sortBy: "created_at",
  sortOrder: "desc",
};

const statusTabs = [
  { key: "PENDING", label: "Pending" },
  { key: "APPROVED", label: "Approved" },
  { key: "PUBLISHED", label: "Published" },
  { key: "REJECTED", label: "Rejected" },
];

const DEFAULT_PAGE = 1;
const DEFAULT_LIMIT = 10;
const rejectReasons = [
  "Inappropriate Content",
  "Spam or Misleading",
  "Harassment or Bullying",
  "Copyright Violation",
  "Violence or Graphic Content",
  "Hate Speech",
];

const clips = [
  {
    uid: "clip-1",
    id: "#848745fsad8",
    tag: "Signing",
    name: "Shiv Sama Rah....",
    postedAt: "23 Apr 2026 | 10:30 PM",
    approvedAt: "24 Apr 2026, 9:00 AM",
    approvedBy: "Farahan",
    rejectedAt: "24 Apr 2026, 9:00 AM",
    rejectedBy: "Ai Agent",
    rejectionReason: "Inappropriate Content",
    publishedAt: "24 Apr 2026, 6:00 Pm",
    publishedBy: "Farahan",
    publishStatus: "Active",
    likes: "12K",
    played: "306",
    earnedXp: "5120",
    gameId: "6a34bed368d0b86e5a...",
    username: "Robin_Doe84",
    status: "APPROVED",
  },
  {
    uid: "clip-2",
    id: "#848745fsad8",
    tag: "Signing",
    name: "Shiv Sama Rah....",
    postedAt: "23 Apr 2026 | 10:30 PM",
    approvedAt: "24 Apr 2026, 9:00 AM",
    approvedBy: "Farahan",
    rejectedAt: "24 Apr 2026, 9:00 AM",
    rejectedBy: "Farahan",
    rejectionReason: "Inappropriate Content",
    publishedAt: "24 Apr 2026, 6:00 Pm",
    publishedBy: "Farahan",
    publishStatus: "Active",
    likes: "5K",
    played: "120",
    earnedXp: "3650",
    gameId: "6a34bed368d0b86e5a...",
    username: "Robin_Doe84",
    status: "APPROVED",
  },
  {
    uid: "clip-3",
    id: "#848745fsad8",
    tag: "Signing",
    name: "Shiv Sama Rah....",
    postedAt: "23 Apr 2026 | 10:30 PM",
    approvedAt: "24 Apr 2026, 9:00 AM",
    approvedBy: "Farahan",
    rejectedAt: "24 Apr 2026, 9:00 AM",
    rejectedBy: "Ai Agent",
    rejectionReason: "Inappropriate Content",
    publishedAt: "24 Apr 2026, 6:00 Pm",
    publishedBy: "Farahan",
    publishStatus: "Active",
    likes: "12K",
    played: "306",
    earnedXp: "5120",
    gameId: "6a34bed368d0b86e5a...",
    username: "Robin_Doe84",
    status: "PUBLISHED",
  },
  {
    uid: "clip-4",
    id: "#848745fsad8",
    tag: "Signing",
    name: "Shiv Sama Rah....",
    postedAt: "23 Apr 2026 | 10:30 PM",
    approvedAt: "24 Apr 2026, 9:00 AM",
    approvedBy: "Farahan",
    rejectedAt: "24 Apr 2026, 9:00 AM",
    rejectedBy: "Farahan",
    rejectionReason: "Inappropriate Content",
    publishedAt: "24 Apr 2026, 6:00 Pm",
    publishedBy: "Farahan",
    publishStatus: "Active",
    likes: "5K",
    played: "120",
    earnedXp: "3650",
    gameId: "6a34bed368d0b86e5a...",
    username: "Robin_Doe84",
    status: "PUBLISHED",
  },
  {
    uid: "clip-5",
    id: "#848745fsad8",
    tag: "Signing",
    name: "Shiv Sama Rah....",
    postedAt: "23 Apr 2026 | 10:30 PM",
    approvedAt: "24 Apr 2026, 9:00 AM",
    approvedBy: "Farahan",
    rejectedAt: "24 Apr 2026, 9:00 AM",
    rejectedBy: "Ai Agent",
    rejectionReason: "Inappropriate Content",
    publishedAt: "24 Apr 2026, 6:00 Pm",
    publishedBy: "Farahan",
    publishStatus: "Active",
    likes: "12K",
    played: "306",
    earnedXp: "5120",
    gameId: "6a34bed368d0b86e5a...",
    username: "Robin_Doe84",
    status: "PENDING",
  },
  {
    uid: "clip-6",
    id: "#848745fsad8",
    tag: "Signing",
    name: "Shiv Sama Rah....",
    postedAt: "23 Apr 2026 | 10:30 PM",
    approvedAt: "24 Apr 2026, 9:00 AM",
    approvedBy: "Farahan",
    rejectedAt: "24 Apr 2026, 9:00 AM",
    rejectedBy: "Ai Agent",
    rejectionReason: "Inappropriate Content",
    publishedAt: "24 Apr 2026, 6:00 Pm",
    publishedBy: "Farahan",
    publishStatus: "Active",
    likes: "12K",
    played: "306",
    earnedXp: "5120",
    gameId: "6a34bed368d0b86e5a...",
    username: "Robin_Doe84",
    status: "REJECTED",
  },
  {
    uid: "clip-7",
    id: "#848745fsad8",
    tag: "Signing",
    name: "Shiv Sama Rah....",
    postedAt: "23 Apr 2026 | 10:30 PM",
    approvedAt: "24 Apr 2026, 9:00 AM",
    approvedBy: "Farahan",
    rejectedAt: "24 Apr 2026, 9:00 AM",
    rejectedBy: "Farahan",
    rejectionReason: "Inappropriate Content",
    publishedAt: "24 Apr 2026, 6:00 Pm",
    publishedBy: "Farahan",
    publishStatus: "Active",
    likes: "5K",
    played: "120",
    earnedXp: "3650",
    gameId: "6a34bed368d0b86e5a...",
    username: "Robin_Doe84",
    status: "REJECTED",
  },
];

const compactFieldSx = {
  "& .MuiOutlinedInput-root": {
    height: 44,
    borderRadius: "8px",
    bgcolor: "#fff",
    fontSize: 14,
  },
  "& .MuiInputLabel-root": {
    color: "#737373",
    fontSize: 12,
  },
};

const StatusPill = ({ active, children, onClick }) => (
  <Button
    onClick={onClick}
    variant={active ? "contained" : "outlined"}
    sx={{
      minWidth: 120,
      height: 44,
      borderRadius: "8px",
      borderColor: "#C4C4C4",
      bgcolor: active ? GOLD : "#fff",
      color: active ? "#fff" : "#737373",
      fontSize: 12,
      fontWeight: 500,
      textTransform: "none",
      "&:hover": {
        bgcolor: active ? "#B8943F" : "#F8F8F8",
        borderColor: active ? "#B8943F" : "#C4C4C4",
      },
    }}
  >
    {children}
  </Button>
);

const ClipPreview = ({ thumbnailUrl, title, onClick }) => (
  <Box
    component="button"
    type="button"
    onClick={onClick}
    sx={{
      width: 96,
      height: 54,
      p: 0,
      border: 0,
      borderRadius: "5px",
      overflow: "hidden",
      position: "relative",
      cursor: "pointer",
      background:
        "linear-gradient(135deg, #1F1F1F 0%, #5B514C 42%, #2E2524 100%)",
    }}
  >
    {thumbnailUrl ? (
      <Box
        component="img"
        src={thumbnailUrl}
        alt={title || "Clip preview"}
        sx={{ position: "absolute", inset: 0, width: "100%", height: "100%", objectFit: "cover" }}
      />
    ) : null}
    <Box sx={{ position: "absolute", inset: 0, bgcolor: "rgba(0, 0, 0, 0.22)" }} />
    <PlayCircleFilledWhiteOutlinedIcon
      sx={{
        position: "absolute",
        left: "50%",
        top: "50%",
        transform: "translate(-50%, -50%)",
        color: "#D13BFF",
        fontSize: 22,
      }}
    />
  </Box>
);

const includesSearch = (value, search) =>
  String(value || "")
    .toLowerCase()
    .includes(search.trim().toLowerCase());

const normalizeResponse = (response) => {
  const payload = response?.data || response || {};
  if (Array.isArray(payload)) {
    return { rows: payload, total: payload.length, pages: 1 };
  }
  const list =
    payload?.items ||
    payload?.rows ||
    payload?.docs ||
    payload?.clips ||
    payload?.data ||
    [];
  const rows = Array.isArray(list) ? list : [];
  const pagination = payload?.pagination || response?.pagination || {};
  const total = Number(
    pagination.total ||
      pagination.totalItems ||
      payload.total ||
      response?.total ||
      rows.length
  );
  const pages = Number(
    pagination.pages ||
      pagination.totalPages ||
      Math.max(Math.ceil(total / DEFAULT_LIMIT), 1)
  );

  return { rows, total, pages: Math.max(pages, 1) };
};

const normalizeDetailResponse = (response) => {
  const payload = response?.data || response || {};
  return payload?.data || payload?.item || payload?.clip || payload;
};

const getFirst = (...values) => values.find((value) => value !== undefined && value !== null && value !== "");

const getClipApiId = (clip) =>
  getFirst(clip?.raw?._id, clip?.raw?.id, clip?.raw?.clipId, clip?.raw?.ugcId, clip?.uid);

const formatDateTime = (value) => {
  if (!value) return "-";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return String(value);
  const day = String(date.getDate()).padStart(2, "0");
  const month = date.toLocaleString("en-US", { month: "short" });
  const year = date.getFullYear();
  const hours = date.getHours();
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const displayHours = hours % 12 || 12;
  const meridiem = hours >= 12 ? "PM" : "AM";
  return `${day} ${month} ${year} | ${displayHours}:${minutes} ${meridiem}`;
};

const formatTags = (tags) => {
  if (Array.isArray(tags)) return tags.join(", ");
  return tags || "-";
};

const normalizeClip = (item, index) => {
  const user = item?.user || item?.userDetails || item?.creator || item?.createdBy || {};
  const engagement = item?.engagementStats || item?.stats || {};
  const status = getFirst(item?.status, "PENDING");
  const displayId = getFirst(item?.clipId, item?.ugcId, item?._id, item?.id, "-");

  return {
    raw: item,
    uid: getFirst(item?._id, item?.id, displayId, `clip-${index}`),
    id: displayId === "-" ? "-" : `#${String(displayId).replace(/^#/, "")}`,
    tag: formatTags(item?.tags),
    name: getFirst(item?.title, item?.clipTitle, item?.name, "-"),
    postedAt: formatDateTime(getFirst(item?.created_at, item?.createdAt, item?.createdOn)),
    approvedAt: formatDateTime(getFirst(item?.approved_at, item?.approvedAt)),
    approvedBy: getFirst(item?.approvedBy?.name, item?.approvedBy, "-"),
    rejectedAt: formatDateTime(getFirst(item?.rejected_at, item?.rejectedAt)),
    rejectedBy: getFirst(item?.rejectedBy?.name, item?.rejectedBy, "-"),
    rejectionReason: getFirst(item?.rejectionReason, item?.rejectReason, "-"),
    publishedAt: formatDateTime(getFirst(item?.published_at, item?.publishedAt)),
    publishedBy: getFirst(item?.publishedBy?.name, item?.publishedBy, "-"),
    publishStatus: String(getFirst(item?.publishStatus, item?.visibilityStatus, "ACTIVE")).toUpperCase(),
    likes: getFirst(item?.likes, engagement?.likes, 0),
    played: getFirst(item?.playCount, engagement?.playCount, engagement?.played, 0),
    earnedXp: getFirst(item?.earnedXp, item?.earnedXP, engagement?.earnedXp, 0),
    gameId: getFirst(item?.gameId, item?.publishedInGameId, "-"),
    username: getFirst(user?.username, user?.displayName, item?.username, "-"),
    userPhoto: getFirst(user?.photo, user?.imageUrl, user?.profileImage),
    thumbnailUrl: getFirst(item?.thumbnailUrl, item?.thumbnail, item?.coverImage, item?.imageUrl),
    videoUrl: getFirst(item?.videoUrl, item?.clipUrl, item?.mediaUrl, item?.url, item?.playUrl),
    description: getFirst(item?.description, item?.caption, item?.body, "-"),
    status,
  };
};

const RapStudio = () => {
  const [filters, setFilters] = useState(initialFilters);
  const [appliedFilters, setAppliedFilters] = useState(initialFilters);
  const [activeStatus, setActiveStatus] = useState("PENDING");
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(DEFAULT_PAGE);
  const [totalPages, setTotalPages] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [statusCounts, setStatusCounts] = useState({});
  const [approveCandidate, setApproveCandidate] = useState(null);
  const [isApproving, setIsApproving] = useState(false);
  const [publishCandidate, setPublishCandidate] = useState(null);
  const [isPublishing, setIsPublishing] = useState(false);
  const [publishGames, setPublishGames] = useState([]);
  const [publishGamesLoading, setPublishGamesLoading] = useState(false);
  const [selectedPublishGame, setSelectedPublishGame] = useState(null);
  const [rejectCandidate, setRejectCandidate] = useState(null);
  const [rejectReason, setRejectReason] = useState(rejectReasons[0]);
  const [rejectMessage, setRejectMessage] = useState("");
  const [isRejecting, setIsRejecting] = useState(false);
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewLoading, setPreviewLoading] = useState(false);
  const [previewDetail, setPreviewDetail] = useState(null);
  const [updatingStatusById, setUpdatingStatusById] = useState({});
  const isApprovedView = activeStatus === "APPROVED";
  const isPublishedView = activeStatus === "PUBLISHED";
  const isRejectedView = activeStatus === "REJECTED";
  const ownerFilterLabel = isPublishedView
    ? "Published by"
    : isRejectedView
    ? "Rejected by"
    : "Approved by";
  const ownerFilterValue = isPublishedView
    ? filters.publishedBy
    : isRejectedView
    ? filters.rejectedBy
    : filters.approvedBy;
  const ownerFilterField = isPublishedView
    ? "publishedBy"
    : isRejectedView
    ? "rejectedBy"
    : "approvedBy";
  const dateFilterPrefix = isPublishedView
    ? "Published on"
    : isRejectedView
    ? "Published on"
    : isApprovedView
    ? "Approved on"
    : "Posted on";
  const tableHeadings = isPublishedView
    ? [
        "Clip ID",
        "Clip",
        "Tag",
        "Clip Name",
        "Photo",
        "Username",
        "Published on",
        "Status",
        "Likes",
      ]
    : isRejectedView
    ? [
        "Clip ID",
        "Clip",
        "Tag",
        "Clip Name",
        "Photo",
        "Username",
        "Rejected on",
        "Rejected by",
        "Rejection Reason",
      ]
    : isApprovedView
    ? ["Clip ID", "Clip", "Tag", "Clip Name", "Photo", "Username", "Approved on", "Approved by", "Action"]
    : ["Clip ID", "Clip", "Tag", "Clip Name", "Posted Date & Time", "Photo", "Username", "Action"];
  const totalClipCount = statusTabs.reduce(
    (sum, status) => sum + Number(statusCounts[status.key] || 0),
    0
  );

  const fetchRapStudioClips = useCallback(async () => {
    setLoading(true);
    try {
      const params = {
        status: activeStatus,
        tags: appliedFilters.tag.trim(),
        search: appliedFilters.username.trim(),
        sortBy: appliedFilters.sortBy,
        sortOrder: appliedFilters.sortOrder,
        page,
        limit: DEFAULT_LIMIT,
      };

      const response = await api_service.getUgcList(params);
      const responseCode = response?.responseCode;
      const status = response?.status;

      if (
        (responseCode && responseCode !== 200 && responseCode !== 201) ||
        (status && status !== 200 && status !== 201 && !responseCode)
      ) {
        throw new Error(response?.message || response?.error?.message || "Failed to fetch clips.");
      }

      const { rows: apiRows, total, pages } = normalizeResponse(response);
      setRows(apiRows.map(normalizeClip));
      setTotalRecords(total);
      setTotalPages(pages);
    } catch (error) {
      setRows([]);
      setTotalRecords(0);
      setTotalPages(1);
      toast.error(error?.message || "Failed to fetch clips.");
    } finally {
      setLoading(false);
    }
  }, [activeStatus, appliedFilters, page]);

  const fetchStatusCounts = useCallback(async () => {
    try {
      const countResults = await Promise.all(
        statusTabs.map(async (status) => {
          const response = await api_service.getUgcList({
            status: status.key,
            tags: appliedFilters.tag.trim(),
            search: appliedFilters.username.trim(),
            sortBy: appliedFilters.sortBy,
            sortOrder: appliedFilters.sortOrder,
            page: DEFAULT_PAGE,
            limit: 1,
          });
          const responseCode = response?.responseCode;
          const apiStatus = response?.status;

          if (
            (responseCode && responseCode !== 200 && responseCode !== 201) ||
            (apiStatus && apiStatus !== 200 && apiStatus !== 201 && !responseCode)
          ) {
            return [status.key, 0];
          }

          const { total } = normalizeResponse(response);
          return [status.key, total];
        })
      );

      setStatusCounts(Object.fromEntries(countResults));
    } catch (error) {
      setStatusCounts({});
      toast.error(error?.message || "Failed to fetch clip counts.");
    }
  }, [appliedFilters]);

  useEffect(() => {
    fetchRapStudioClips();
  }, [fetchRapStudioClips]);

  useEffect(() => {
    fetchStatusCounts();
  }, [fetchStatusCounts]);

  const handleFilterChange = (field, value) => {
    setFilters((prev) => ({ ...prev, [field]: value }));
  };

  const applyFilters = () => {
    setPage(DEFAULT_PAGE);
    setAppliedFilters(filters);
  };

  const handleStatusChange = (status) => {
    setActiveStatus(status);
    setPage(DEFAULT_PAGE);
  };

  const clearFilters = () => {
    setFilters(initialFilters);
    setAppliedFilters(initialFilters);
    setActiveStatus("PENDING");
    setPage(DEFAULT_PAGE);
  };

  const updateClipStatus = (uid, status) => {
    setRows((prev) =>
      prev.map((clip) =>
        clip.uid === uid ? { ...clip, status } : clip
      )
    );
  };

  const handlePublishStatusChange = async (clip, nextStatus) => {
    const clipId = getClipApiId(clip);
    if (!clipId) {
      toast.error("Missing clip ID.");
      return;
    }

    const previousStatus = clip.publishStatus;
    setRows((prev) =>
      prev.map((row) =>
        row.uid === clip.uid ? { ...row, publishStatus: nextStatus } : row
      )
    );
    setUpdatingStatusById((prev) => ({ ...prev, [clip.uid]: true }));

    try {
      const response = await api_service.updateUgcStatus({
        clipId,
        status: nextStatus,
      });
      const responseCode = response?.responseCode;
      const status = response?.status;

      if (
        (responseCode && responseCode !== 200 && responseCode !== 201) ||
        (status && status !== 200 && status !== 201 && !responseCode)
      ) {
        throw new Error(response?.message || response?.error?.message || "Failed to update status.");
      }

      toast.success("Status updated.");
    } catch (error) {
      setRows((prev) =>
        prev.map((row) =>
          row.uid === clip.uid ? { ...row, publishStatus: previousStatus } : row
        )
      );
      toast.error(error?.message || "Failed to update status.");
    } finally {
      setUpdatingStatusById((prev) => ({ ...prev, [clip.uid]: false }));
    }
  };

  const openApproveDialog = (clip) => {
    setApproveCandidate(clip);
  };

  const closeApproveDialog = () => {
    if (isApproving) return;
    setApproveCandidate(null);
  };

  const confirmApproveClip = async () => {
    const clipId = getClipApiId(approveCandidate);
    if (!clipId) {
      toast.error("Missing clip ID.");
      return;
    }

    setIsApproving(true);
    try {
      const response = await api_service.approveUgcClip({ clipId });
      const responseCode = response?.responseCode;
      const status = response?.status;

      if (
        (responseCode && responseCode !== 200 && responseCode !== 201) ||
        (status && status !== 200 && status !== 201 && !responseCode)
      ) {
        throw new Error(response?.message || response?.error?.message || "Failed to approve clip.");
      }

      toast.success("Clip approved successfully.");
      setApproveCandidate(null);
      await Promise.all([fetchRapStudioClips(), fetchStatusCounts()]);
    } catch (error) {
      toast.error(error?.message || "Failed to approve clip.");
    } finally {
      setIsApproving(false);
    }
  };

  const openPublishDialog = async (clip) => {
    setPublishCandidate(clip);
    setSelectedPublishGame(null);
    setPublishGamesLoading(true);
    try {
      const response = await api_service.getTambolaGamesList({ _page: 1, _limit: 30 });
      const responseCode = response?.responseCode;
      const status = response?.status;

      if (
        (responseCode && responseCode !== 200 && responseCode !== 201) ||
        (status && status !== 200 && status !== 201 && !responseCode)
      ) {
        throw new Error(response?.message || response?.error?.message || "Failed to fetch games.");
      }

      const games = Array.isArray(response?.data) ? response.data : [];
      setPublishGames(games);
    } catch (error) {
      setPublishGames([]);
      toast.error(error?.message || "Failed to fetch games.");
    } finally {
      setPublishGamesLoading(false);
    }
  };

  const closePublishDialog = () => {
    if (isPublishing) return;
    setPublishCandidate(null);
    setSelectedPublishGame(null);
  };

  const confirmPublishClip = async () => {
    const clipId = getClipApiId(publishCandidate);
    const selectedGameId = selectedPublishGame?._id || selectedPublishGame?.id;
    if (!clipId) {
      toast.error("Missing clip ID.");
      return;
    }

    if (!selectedGameId) {
      toast.error("Please select a game.");
      return;
    }

    setIsPublishing(true);
    try {
      const response = await api_service.publishUgcClip({
        clipId,
        gameId: selectedGameId,
      });
      const responseCode = response?.responseCode;
      const status = response?.status;

      if (
        (responseCode && responseCode !== 200 && responseCode !== 201) ||
        (status && status !== 200 && status !== 201 && !responseCode)
      ) {
        throw new Error(response?.message || response?.error?.message || "Failed to publish clip.");
      }

      toast.success("Clip published successfully.");
      setPublishCandidate(null);
      setSelectedPublishGame(null);
      await Promise.all([fetchRapStudioClips(), fetchStatusCounts()]);
    } catch (error) {
      toast.error(error?.message || "Failed to publish clip.");
    } finally {
      setIsPublishing(false);
    }
  };

  const openRejectDialog = (clip) => {
    setRejectCandidate(clip);
    setRejectReason(rejectReasons[0]);
    setRejectMessage("");
  };

  const closeRejectDialog = () => {
    if (isRejecting) return;
    setRejectCandidate(null);
    setRejectReason(rejectReasons[0]);
    setRejectMessage("");
  };

  const confirmRejectClip = async () => {
    const clipId = getClipApiId(rejectCandidate);
    if (!clipId) {
      toast.error("Missing clip ID.");
      return;
    }

    setIsRejecting(true);
    try {
      const response = await api_service.rejectUgcClip({
        clipId,
        reason: rejectReason,
      });
      const responseCode = response?.responseCode;
      const status = response?.status;

      if (
        (responseCode && responseCode !== 200 && responseCode !== 201) ||
        (status && status !== 200 && status !== 201 && !responseCode)
      ) {
        throw new Error(response?.message || response?.error?.message || "Failed to reject clip.");
      }

      toast.success("Clip rejected successfully.");
      setRejectCandidate(null);
      setRejectReason(rejectReasons[0]);
      setRejectMessage("");
      await Promise.all([fetchRapStudioClips(), fetchStatusCounts()]);
    } catch (error) {
      toast.error(error?.message || "Failed to reject clip.");
    } finally {
      setIsRejecting(false);
    }
  };

  const openClipPreview = async (clip) => {
    const clipId = getClipApiId(clip);
    if (!clipId) {
      toast.error("Missing clip ID.");
      return;
    }

    setPreviewOpen(true);
    setPreviewLoading(true);
    setPreviewDetail(clip);
    try {
      const response = await api_service.getUgcDetail({ clipId });
      const responseCode = response?.responseCode;
      const status = response?.status;

      if (
        (responseCode && responseCode !== 200 && responseCode !== 201) ||
        (status && status !== 200 && status !== 201 && !responseCode)
      ) {
        throw new Error(response?.message || response?.error?.message || "Failed to load clip detail.");
      }

      const detail = normalizeDetailResponse(response);
      setPreviewDetail(normalizeClip({ ...clip.raw, ...detail }, 0));
    } catch (error) {
      toast.error(error?.message || "Failed to load clip detail.");
    } finally {
      setPreviewLoading(false);
    }
  };

  const closeClipPreview = () => {
    setPreviewOpen(false);
    setPreviewDetail(null);
    setPreviewLoading(false);
  };

  return (
    <Box sx={{ width: "100%", px: 3, pt: 3, pb: 4, bgcolor: "#fff" }}>
      <Typography
        variant="h5"
        sx={{
          mb: 2.5,
          fontWeight: 500,
          letterSpacing: "0.8px",
          color: "#000",
        }}
      >
        RAPSTUDIO
      </Typography>

      <Card
        elevation={3}
        sx={{
          p: 2,
          mb: 2.5,
          borderRadius: 0,
          boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.25)",
        }}
      >
        <Typography
          variant="h5"
          align="center"
          sx={{ mb: 1.5, fontWeight: 500, letterSpacing: "0.8px" }}
        >
          Filters
        </Typography>

        <Grid container spacing={1.5} alignItems="center">
          <Grid item xs={12} md={2.1}>
            <TextField
              fullWidth
              placeholder="Search by clip title"
              value={filters.username}
              onChange={(event) => handleFilterChange("username", event.target.value)}
              sx={compactFieldSx}
            />
          </Grid>
          <Grid item xs={12} md={2.1}>
            <TextField
              fullWidth
              placeholder="Clip ID"
              value={filters.clipId}
              onChange={(event) => handleFilterChange("clipId", event.target.value)}
              sx={compactFieldSx}
            />
          </Grid>
          <Grid item xs={12} md={2.1}>
            <TextField
              fullWidth
              placeholder="Tags"
              value={filters.tag}
              onChange={(event) => handleFilterChange("tag", event.target.value)}
              sx={compactFieldSx}
            />
          </Grid>
          {isApprovedView || isPublishedView || isRejectedView ? (
            <Grid item xs={12} md={1.8}>
              <TextField
                fullWidth
                placeholder={ownerFilterLabel}
                value={ownerFilterValue}
                onChange={(event) => handleFilterChange(ownerFilterField, event.target.value)}
                sx={compactFieldSx}
              />
            </Grid>
          ) : (
            <Grid item xs={12} md={1.8} />
          )}
          <Grid item xs={12} md={1.8}>
            <TextField
              fullWidth
              label={`${dateFilterPrefix} From`}
              type="date"
              value={filters.postedFrom}
              onChange={(event) => handleFilterChange("postedFrom", event.target.value)}
              InputLabelProps={{ shrink: true }}
              sx={compactFieldSx}
            />
          </Grid>
          <Grid item xs={12} md={1.8}>
            <TextField
              fullWidth
              label={`${dateFilterPrefix} To`}
              type="date"
              value={filters.postedTo}
              onChange={(event) => handleFilterChange("postedTo", event.target.value)}
              InputLabelProps={{ shrink: true }}
              sx={compactFieldSx}
            />
          </Grid>
        </Grid>

        <Grid container spacing={1.5} alignItems="center" sx={{ mt: 1 }}>
          <Grid item xs={12} md="auto">
            <Box
              sx={{
                width: 250,
                maxWidth: "100%",
                height: 54,
                px: 1.5,
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                bgcolor: "#EEE",
                borderRadius: "5px",
                boxShadow: "inset 0px 0px 6px rgba(0, 0, 0, 0.24)",
              }}
            >
              <Typography sx={{ color: "#737373", fontWeight: 600 }}>
                Total Clips
              </Typography>
              <Typography
                sx={{
                  fontSize: 24,
                  fontWeight: 800,
                  background: "linear-gradient(270deg, #822AFF 0%, #FF00F2 100%)",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                }}
              >
                {totalClipCount || totalRecords}
              </Typography>
            </Box>
          </Grid>

          <Grid item xs={12} md>
            <Stack
              direction={{ xs: "column", sm: "row" }}
              spacing={1}
              sx={{ bgcolor: "#F8F8F8", borderRadius: "10px", p: 0.5, width: "fit-content" }}
            >
              {statusTabs.map((status) => (
                <StatusPill
                  key={status.key}
                  active={activeStatus === status.key}
                  onClick={() => handleStatusChange(status.key)}
                >
                  {status.label} ({statusCounts[status.key] || 0})
                </StatusPill>
              ))}
            </Stack>
          </Grid>

          {isPublishedView ? (
            <Grid item xs={12} md={1.3}>
              <FormControl fullWidth size="small" sx={compactFieldSx}>
                <InputLabel>Status</InputLabel>
                <Select
                  label="Status"
                  value={filters.status}
                  onChange={(event) => handleFilterChange("status", event.target.value)}
                >
                  <MenuItem value="ACTIVE">Active</MenuItem>
                  <MenuItem value="INACTIVE">Inactive</MenuItem>
                </Select>
              </FormControl>
            </Grid>
          ) : null}

          <Grid item xs={12} md={1.3}>
            <FormControl fullWidth size="small" sx={compactFieldSx}>
              <InputLabel>Sort By</InputLabel>
              <Select
                label="Sort By"
                value={filters.sortBy}
                onChange={(event) => handleFilterChange("sortBy", event.target.value)}
              >
                <MenuItem value="created_at">Created At</MenuItem>
                <MenuItem value="updated_at">Updated At</MenuItem>
                <MenuItem value="likes">Likes</MenuItem>
                <MenuItem value="playCount">Play Count</MenuItem>
                <MenuItem value="title">Title</MenuItem>
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={12} md={isPublishedView ? 1.3 : 1.8}>
            <FormControl fullWidth size="small" sx={compactFieldSx}>
              <InputLabel>Sort Order</InputLabel>
              <Select
                label="Sort Order"
                value={filters.sortOrder}
                onChange={(event) => handleFilterChange("sortOrder", event.target.value)}
              >
                <MenuItem value="desc">Descending</MenuItem>
                <MenuItem value="asc">Ascending</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} md="auto">
            <Button
              variant="contained"
              onClick={applyFilters}
              sx={{
                height: 50,
                minWidth: 120,
                bgcolor: GOLD,
                color: "#fff",
                borderRadius: "8px",
                fontSize: 12,
                "&:hover": { bgcolor: "#B8943F" },
              }}
            >
              APPLY FILTER
            </Button>
          </Grid>
          <Grid item xs={12} md="auto">
            <Button
              variant="outlined"
              onClick={clearFilters}
              sx={{
                height: 50,
                minWidth: 124,
                borderColor: "#C4C4C4",
                color: "#737373",
                borderRadius: "8px",
                fontSize: 12,
              }}
            >
              CLEAR FILTER
            </Button>
          </Grid>
        </Grid>
      </Card>

      <TableContainer
        component={Card}
        elevation={3}
        sx={{
          borderRadius: 0,
          boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.25)",
        }}
      >
        <Table sx={{ minWidth: isRejectedView ? 1900 : "auto" }}>
          <TableHead>
            <TableRow>
              {tableHeadings.map((heading) => (
                <TableCell
                  key={heading}
                  sx={{
                    py: 2,
                    fontSize: 16,
                    fontWeight: 600,
                    letterSpacing: "0.8px",
                    color: "#000",
                    whiteSpace: "nowrap",
                  }}
                >
                  {heading}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {loading ? (
              <TableRow>
                <TableCell colSpan={tableHeadings.length} align="center" sx={{ py: 5 }}>
                  <CircularProgress size={28} />
                </TableCell>
              </TableRow>
            ) : rows.map((clip) => (
              <TableRow key={clip.uid} sx={{ height: 82 }}>
                <TableCell sx={{ fontSize: 15 }}>{clip.id}</TableCell>
                <TableCell>
                  <ClipPreview
                    thumbnailUrl={clip.thumbnailUrl}
                    title={clip.name}
                    onClick={() => openClipPreview(clip)}
                  />
                </TableCell>
                <TableCell sx={{ fontSize: 15 }}>{clip.tag}</TableCell>
                <TableCell sx={{ fontSize: 15 }}>{clip.name}</TableCell>
                {isApprovedView || isPublishedView || isRejectedView ? null : (
                  <TableCell sx={{ fontSize: 15, whiteSpace: "nowrap" }}>
                    {clip.postedAt}
                  </TableCell>
                )}
                <TableCell>
                  <Avatar
                    sx={{
                      width: 54,
                      height: 54,
                      bgcolor: "#D9A46F",
                      color: "#5B2B18",
                      fontWeight: 700,
                    }}
                  >
                    RD
                  </Avatar>
                </TableCell>
                <TableCell sx={{ fontSize: 15 }}>{clip.username}</TableCell>
                {isApprovedView ? (
                  <>
                    <TableCell sx={{ fontSize: 15, whiteSpace: "nowrap" }}>
                      {clip.approvedAt}
                    </TableCell>
                    <TableCell sx={{ fontSize: 15 }}>{clip.approvedBy}</TableCell>
                  </>
                ) : null}
                {isPublishedView ? (
                  <>
                    <TableCell sx={{ fontSize: 15, whiteSpace: "nowrap" }}>
                      {clip.publishedAt}
                    </TableCell>
                    <TableCell>
                      <FormControl size="small" sx={{ minWidth: 120, ...compactFieldSx }}>
                        <Select
                          value={clip.publishStatus}
                          onChange={(event) => handlePublishStatusChange(clip, event.target.value)}
                          disabled={Boolean(updatingStatusById[clip.uid])}
                        >
                          <MenuItem value="ACTIVE">Active</MenuItem>
                          <MenuItem value="INACTIVE">Inactive</MenuItem>
                        </Select>
                      </FormControl>
                    </TableCell>
                    <TableCell sx={{ fontSize: 15 }}>{clip.likes}</TableCell>
                  </>
                ) : null}
                {isRejectedView ? (
                  <>
                    <TableCell sx={{ fontSize: 15, whiteSpace: "nowrap" }}>
                      {clip.rejectedAt}
                    </TableCell>
                    <TableCell sx={{ fontSize: 15 }}>{clip.rejectedBy}</TableCell>
                    <TableCell sx={{ fontSize: 15, whiteSpace: "nowrap" }}>
                      {clip.rejectionReason}
                    </TableCell>
                  </>
                ) : null}
                {!isRejectedView && !isPublishedView ? (
                <TableCell>
                  {isApprovedView ? (
                    <Button
                      variant="contained"
                      size="small"
                      onClick={() => openPublishDialog(clip)}
                      sx={{
                        minWidth: 82,
                        height: 34,
                        color: "#fff",
                        bgcolor: GOLD,
                        borderColor: GOLD,
                        borderRadius: "8px",
                        fontSize: 12,
                        letterSpacing: "0.5px",
                        "&:hover": {
                          borderColor: "#B8943F",
                          bgcolor: "#B8943F",
                        },
                      }}
                    >
                      PUBLISH
                    </Button>
                  ) : (
                    <Stack direction="row" spacing={1}>
                      <Button
                        variant="outlined"
                        size="small"
                        onClick={() => openApproveDialog(clip)}
                        sx={{
                          minWidth: 82,
                          color: GREEN,
                          borderColor: GREEN,
                          fontSize: 12,
                          "&:hover": {
                            borderColor: GREEN,
                            bgcolor: "rgba(38, 192, 46, 0.08)",
                          },
                        }}
                      >
                        APPROVE
                      </Button>
                      <Button
                        variant="outlined"
                        size="small"
                        onClick={() => openRejectDialog(clip)}
                        sx={{
                          minWidth: 82,
                          color: RED,
                          borderColor: RED,
                          fontSize: 12,
                          "&:hover": {
                            borderColor: RED,
                            bgcolor: "rgba(211, 47, 47, 0.08)",
                          },
                        }}
                      >
                        REJECT
                      </Button>
                    </Stack>
                  )}
                </TableCell>
                ) : null}
              </TableRow>
            ))}
            {!loading && rows.length === 0 ? (
              <TableRow>
                <TableCell colSpan={tableHeadings.length} align="center" sx={{ py: 5 }}>
                  No clips found.
                </TableCell>
              </TableRow>
            ) : null}
          </TableBody>
        </Table>
      </TableContainer>

      <Box display="flex" justifyContent="center" mt={2}>
        <Pagination
          count={totalPages}
          page={page}
          onChange={(_, nextPage) => setPage(nextPage)}
          color="secondary"
          showFirstButton
          showLastButton
        />
      </Box>

      <Dialog
        open={Boolean(approveCandidate)}
        onClose={closeApproveDialog}
        maxWidth={false}
        PaperProps={{
          sx: {
            maxWidth: "calc(100vw - 48px)",
            borderRadius: 0,
            boxShadow: "0px 5px 18px rgba(0, 0, 0, 0.22)",
          },
        }}
      >
        <Box
          sx={{
            bgcolor: "#F4F4F4",
            px: 2.5,
            py: 2.25,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Typography
            sx={{
              fontSize: 20,
              fontWeight: 500,
              lineHeight: "32px",
              letterSpacing: "0.8px",
              color: "#000",
            }}
          >
            Confirm Approve
          </Typography>
        </Box>
        <DialogContent sx={{ px: 2.5, pt: 3.5, pb: 2 }}>
          <Typography
            sx={{
              fontSize: 14,
              lineHeight: "20px",
              letterSpacing: "0.5px",
              color: "#111827",
            }}
          >
            Are you sure you want to approve this clip?
          </Typography>
        </DialogContent>
        <DialogActions sx={{ px: 2.5, pb: 2.5, gap: 1, justifyContent: "flex-end" }}>
          <Button
            variant="outlined"
            onClick={closeApproveDialog}
            disabled={isApproving}
            sx={{
              width: 124,
              height: 50,
              borderRadius: "8px",
              borderColor: "#C4C4C4",
              color: "#737373",
              fontSize: 14,
              letterSpacing: "0.5px",
            }}
          >
            CANCEL
          </Button>
          <Button
            variant="contained"
            onClick={confirmApproveClip}
            disabled={isApproving}
            sx={{
              width: 120,
              height: 50,
              borderRadius: "8px",
              bgcolor: GOLD,
              color: "#fff",
              fontSize: 14,
              letterSpacing: "0.5px",
              "&:hover": { bgcolor: "#B8943F" },
            }}
          >
            {isApproving ? "APPROVING..." : "APPROVE"}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={Boolean(publishCandidate)}
        onClose={closePublishDialog}
        maxWidth={false}
        PaperProps={{
          sx: {
            maxWidth: "calc(100vw - 450px)",
            borderRadius: 0,
            boxShadow: "0px 5px 18px rgba(0, 0, 0, 0.22)",

          },
        }}
      >
        <Box sx={{ bgcolor: "#F4F4F4", px: 2.5, py: 2.25 }}>
          <Typography
            sx={{
              fontSize: 20,
              fontWeight: 500,
              lineHeight: "32px",
              letterSpacing: "0.8px",
              color: "#000",
            }}
          >
            Select Game to Publish
          </Typography>
        </Box>
        <DialogContent sx={{ px: 2.5, pt: 2.5, pb: 2, bgcolor: "#F4F4F4" }}>
          {publishGamesLoading ? (
            <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
              <CircularProgress size={28} />
            </Box>
          ) : publishGames.length > 0 ? (
            <Grid container spacing={2} sx={{ maxHeight: 440, overflowY: "auto",justifyContent: "center" }}>
              {publishGames.map((game) => {
                const gameId = game?._id || game?.id;
                const isSelected = selectedPublishGame?._id === gameId || selectedPublishGame?.id === gameId;
                const gameImage =
                  game?.banner?.fullWidth ||
                  game?.banner?.thumbnail ||
                  game?.banner ||
                  game?.imageUrl ||
                  game?.thumbnailUrl;
                return (
                  <Grid item xs={12} sm={6} key={gameId} sx={{ width: "298px", height:"246px" }}>
                    <Box
                      component="button"
                      type="button"
                      onClick={() => setSelectedPublishGame(game)}
                      sx={{
                        width: "100%",
                        p: 0,
                        border: 0,
                        bgcolor: "transparent",
                        textAlign: "left",
                        cursor: "pointer",
                      }}
                    >
                      <Box
                        sx={{
                          overflow: "hidden",
                          borderRadius: "8px",
                          boxShadow: isSelected
                            ? "0px 0px 0px 2px #CCA752, 0px 2px 8px rgba(0,0,0,0.16)"
                            : "0px 2px 8px rgba(0,0,0,0.16)",
                        }}
                      >
                        <Box
                          sx={{
                            width: "100%",
                            height: 96,
                            bgcolor: "#E9E9E9",
                            backgroundImage: gameImage ? `url(${gameImage})` : "none",
                            backgroundSize: "cover",
                            backgroundPosition: "center",
                            borderTopLeftRadius: "8px",
                            borderTopRightRadius: "8px",
                          }}
                        />
                        <Box
                          sx={{
                            bgcolor: "#fff",
                            border: "1px solid #D3D3D3",
                            borderTop: 0,
                            borderBottomLeftRadius: "8px",
                            borderBottomRightRadius: "8px",
                            px: 1.25,
                            py: 1,
                            minHeight: 84,
                          }}
                        >
                          <Typography
                            sx={{
                              fontSize: 10,
                              fontWeight: 600,
                              lineHeight: "12px",
                              color: "#000",
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                            }}
                          >
                            Game ID: {gameId}
                          </Typography>
                          <Typography
                            sx={{
                              fontSize: 10,
                              fontWeight: 600,
                              lineHeight: "12px",
                              color: "#000",
                              mt: 0.75,
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                            }}
                          >
                            Title: {game?.title || "Untitled Game"}
                          </Typography>
                          <Grid container spacing={0.5} sx={{ mt: 0.75, display: "flex", justifyContent: "space-between" }}>
                            <Grid item xs={6}>
                              <Typography sx={{ fontSize: 8, lineHeight: "12px", color: "rgba(0,0,0,0.6)" }}>
                                Trigger Time: {game?.triggerTime || "-"}
                              </Typography>
                              <Typography sx={{ fontSize: 8, lineHeight: "12px", color: "rgba(0,0,0,0.6)", textAlign: "right" }}>
                                Ticket Price: {game?.ticketPrice?.rapCoin ?? "-"} RapCoins
                              </Typography>
                            </Grid>
                            <Grid item xs={6}>
                              
                            <Typography sx={{ fontSize: 8, lineHeight: "12px", color: "rgba(0,0,0,0.6)" }}>
                                Daily GoLive: {game?.dailyGoLiveTime || "-"}
                              </Typography>
                              <Typography sx={{ fontSize: 8, lineHeight: "12px", color: "rgba(0,0,0,0.6)", textAlign: "right" }}>
                                Status: {game?.status || "-"}
                              </Typography>
                            </Grid>
                          </Grid>
                        </Box>
                      </Box>
                    </Box>
                  </Grid>
                );
              })}
            </Grid>
          ) : (
            <Typography sx={{ fontSize: 14, color: "#111827" }}>
              No games found.
            </Typography>
          )}
        </DialogContent>
        <DialogActions sx={{ px: 2.5, pb: 2.5, gap: 1, justifyContent: "flex-end" }}>
          <Button
            variant="outlined"
            onClick={closePublishDialog}
            disabled={isPublishing}
            sx={{
              width: 124,
              height: 50,
              borderRadius: "8px",
              borderColor: "#C4C4C4",
              color: "#737373",
              fontSize: 14,
              letterSpacing: "0.5px",
              "&:hover": {
                borderColor: "#C4C4C4",
                bgcolor: "#fff",
              },
            }}
          >
            CANCEL
          </Button>
          <Button
            variant="contained"
            onClick={confirmPublishClip}
            disabled={isPublishing || publishGamesLoading || !selectedPublishGame}
            sx={{
              width: 120,
              height: 50,
              borderRadius: "8px",
              bgcolor: GOLD,
              color: "#fff",
              fontSize: 14,
              letterSpacing: "0.5px",
              "&:hover": { bgcolor: "#B8943F" },
            }}
          >
            {isPublishing ? "PUBLISHING..." : "PUBLISH"}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={Boolean(rejectCandidate)}
        onClose={closeRejectDialog}
        maxWidth={false}
        PaperProps={{
          sx: {
            width: 495,
            maxWidth: "calc(100vw - 48px)",
            borderRadius: 0,
            boxShadow: "0px 5px 18px rgba(0, 0, 0, 0.22)",
          },
        }}
      >
        <Box sx={{ bgcolor: "#F4F4F4", px: 2.5, py: 2.25 }}>
          <Typography
            sx={{
              fontSize: 20,
              fontWeight: 500,
              lineHeight: "32px",
              letterSpacing: "0.8px",
              color: "#000",
            }}
          >
            Select a Reason to Reject
          </Typography>
        </Box>
        <DialogContent sx={{ px: 2.5, pt: 3, pb: 1 }}>
          <RadioGroup value={rejectReason} onChange={(event) => setRejectReason(event.target.value)}>
            {rejectReasons.map((reason) => (
              <Box
                key={reason}
                component="label"
                sx={{
                  width: "100%",
                  height: 44,
                  px: 1.5,
                  display: "flex",
                  alignItems: "center",
                  gap: 1.5,
                  cursor: "pointer",
                  borderRadius: "8px",
                }}
              >
                <Radio
                  value={reason}
                  checked={rejectReason === reason}
                  sx={{
                    p: 0,
                    color: "#C4C4C4",
                    "&.Mui-checked": { color: GOLD },
                  }}
                />
                <Typography
                  sx={{
                    fontSize: 14,
                    lineHeight: "20px",
                    letterSpacing: "0.5px",
                    color: "#111827",
                  }}
                >
                  {reason}
                </Typography>
              </Box>
            ))}
          </RadioGroup>
          <TextField
            fullWidth
            multiline
            minRows={4}
            placeholder="Additional Message..."
            value={rejectMessage}
            onChange={(event) => setRejectMessage(event.target.value)}
            sx={{
              mt: 2,
              "& .MuiOutlinedInput-root": {
                borderRadius: "8px",
                fontSize: 14,
                alignItems: "flex-start",
              },
              "& textarea::placeholder": {
                color: "#111827",
                opacity: 0.5,
              },
            }}
          />
        </DialogContent>
        <DialogActions sx={{ px: 2.5, pb: 2.5, gap: 1, justifyContent: "flex-end" }}>
          <Button
            variant="outlined"
            onClick={closeRejectDialog}
            disabled={isRejecting}
            sx={{
              width: 124,
              height: 50,
              borderRadius: "8px",
              borderColor: "#C4C4C4",
              color: "#737373",
              fontSize: 14,
              letterSpacing: "0.5px",
            }}
          >
            CANCEL
          </Button>
          <Button
            variant="contained"
            onClick={confirmRejectClip}
            disabled={isRejecting}
            sx={{
              width: 120,
              height: 50,
              borderRadius: "8px",
              bgcolor: GOLD,
              color: "#fff",
              fontSize: 14,
              letterSpacing: "0.5px",
              "&:hover": { bgcolor: "#B8943F" },
            }}
          >
            {isRejecting ? "REJECTING..." : "REJECT"}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={previewOpen}
        onClose={closeClipPreview}
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 0,
            boxShadow: "0px 5px 18px rgba(0, 0, 0, 0.22)",
          },
        }}
      >
        <Box sx={{ bgcolor: "#F4F4F4", px: 2.5, py: 2.25, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <Typography
            sx={{
              fontSize: 20,
              fontWeight: 500,
              lineHeight: "32px",
              letterSpacing: "0.8px",
              color: "#000",
            }}
          >
            Clip Preview
          </Typography>
          <IconButton
            onClick={closeClipPreview}
            sx={{
              width: 32,
              height: 32,
              bgcolor: "#C4C4C4",
              borderRadius: "100px",
              color: "#fff",
              "&:hover": { bgcolor: "#AFAFAF" },
            }}
          >
            <CloseIcon sx={{ fontSize: 20 }} />
          </IconButton>
        </Box>
        <DialogContent sx={{ p: 2.5 }}>
          {previewLoading ? (
            <Box sx={{ display: "flex", justifyContent: "center", py: 5 }}>
              <CircularProgress size={28} />
            </Box>
          ) : previewDetail ? (
            <Box sx={{ display: "flex",flexDirection: "column", py: 5  }}>

                <Box
                  sx={{
                    width: "100%",
                    aspectRatio: "9 / 16",
                    maxHeight: 520,
                    bgcolor: "#111",
                    borderRadius: "8px",
                    overflow: "hidden",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  {previewDetail.videoUrl ? (
                    <Box
                      component="video"
                      src={previewDetail.videoUrl}
                      poster={previewDetail.thumbnailUrl}
                      controls
                      sx={{ width: "100%", height: "100%", objectFit: "cover" }}
                    />
                  ) : previewDetail.thumbnailUrl ? (
                    <Box
                      component="img"
                      src={previewDetail.thumbnailUrl}
                      alt={previewDetail.name}
                      sx={{ width: "100%", height: "100%", objectFit: "cover" }}
                    />
                  ) : (
                    <PlayCircleFilledWhiteOutlinedIcon sx={{ color: "#D13BFF", fontSize: 64 }} />
                  )}
                </Box>
                <Stack spacing={3} sx={{ pt: 1 }}>
                  {[
                    ["Clip Name", previewDetail.name],
                    ["Tag", previewDetail.tag],
                    ["Posted Date & Time", previewDetail.postedAt],
                  ].map(([label, value]) => (
                    <Box key={label} sx={{ display: "flex",  justifyContent: "space-between", alignItems: "center" }}>
                      <Typography
                        sx={{
                          fontSize: 20,
                          fontWeight: 500,
                          lineHeight: "32px",
                          letterSpacing: "0.8px",
                          color: "#000",
                        }}
                      >
                        {label}
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: 20,
                          fontWeight: 400,
                          lineHeight: "32px",
                          letterSpacing: "0.8px",
                          color: "#000",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                      >
                        {value || "-"}
                      </Typography>
                    </Box>
                  ))}
                </Stack>
            </Box>
          ) : null}
        </DialogContent>
        
      </Dialog>
    </Box>
  );
};

export default RapStudio;
